export default "__VITE_ASSET__DkF$mZO5__"